export enum WorkItemStatusEnum {
    PAUSED ="PAUSED" ,
    COMPLETED ="COMPLETED",
    REOPEN = "REOPEN",
    NEW = "NEW",
    INPROGRESS = "INPROGRESS",
    ASSIGNED = "ASSIGNED",
    PENDING_VERIFICATION = "PENDING_VERIFICATION",
    AUTOPAUSED = "AUTOPAUSED"
}